<div class="report-selection">
    <div class="grower">
        <app-pick-one [choices]="numberOfBuildsChoices" (pick)="pickNumberOfBuildsChoice($event)" key="nbr-of-builds" title="Select number of builds"></app-pick-one>
    </div>
    <div class="grower">
        <app-pick-one [choices]="buildsToViewChoices" (pick)="pickBuildsToViewChoice($event)" key="builds-to-view" title="Select date range"></app-pick-one>
    </div>
    <button [disabled]="!readyToViewReport()" 
        mat-button mat-raised-button color="accent" 
        (click)="load()">{{reportButtonText()}}
    </button>
</div>
<div>
    <app-build-health-report (loaded)="onReportIsLoaded()"></app-build-health-report>
</div>